/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BaseResponse } from '../../models/base-response';
import { GrantListResponse } from '../../models/grant-list-response';

export interface IdentityControllerGetGrants$Params {
}

export function identityControllerGetGrants(http: HttpClient, rootUrl: string, params?: IdentityControllerGetGrants$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: GrantListResponse;
}>> {
  const rb = new RequestBuilder(rootUrl, identityControllerGetGrants.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BaseResponse & {
      'data'?: GrantListResponse;
      }>;
    })
  );
}

identityControllerGetGrants.PATH = '/identity/grants';
